import '@babel/polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import GoogleAnalytics from './GoogleAnalytics';
import App from '../common/app';

ReactDOM.hydrate(
  <BrowserRouter>
    <GoogleAnalytics id={process.env.GA_ID}>
      <App />
    </GoogleAnalytics>
  </BrowserRouter>,
  document.getElementById('root')
);
